export const USER_DATA = [
  {
    id: 1,
    firstName: "Suman",
    lastName: "Kumar",
    email: "suman@test.com",
    age: 10
  },
  {
    id: 2,
    firstName: "Rahul",
    lastName: "Kumar",
    email: "rahul@test.com",
    age: 15
  },
];
